<template>
  <div class="bigScreen-wrap">bigScreen页面</div>
</template>
<script>
import api from '@common/api/index.js'
export default {
  name: "bigScreen",
  // 引用组件
  components: {},
  data () {
    return {};
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate () { },
  //实例已经创建完成之后被调用。
  create () { },
  // el被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () { },
  // keep-alive组件激活时调用
  activated () { },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated () { },
  //当前路由改变
  beforeRouteUpdate () { },
  // Vue 实例销毁后调用
  destroyed () { },
  // 计算属性
  computed: {},
  // 数据监听
  watch: {},
  // 方法定义
  methods: {}
};
</script>
<style lang="scss" scoped>
.bigScreen-wrap {
}
</style>